import { normalizeBase64String } from '@thoughtspot/codec-util';
import { downloadFileUtil } from "../../../utils/file-download.util";
export const zipFileExt = '.zip';
export const appType = 'application/x-yaml';
export const tslFileExt = '.tml';
export const zipType = 'application/zip';
export const ROLES = 'ROLE';
const downloadFile = (epack, customFileName, containsMultipleObjects, shouldExportDependencies) => {
    const objects = epack.object;
    let type = '';
    let blobContent;
    let fileName = customFileName;
    if (containsMultipleObjects || shouldExportDependencies) {
        const normalized = normalizeBase64String(epack.zipFile);
        const buffer = new Uint8Array(Array.from(atob(normalized), (c) => c.charCodeAt(0)));
        blobContent = buffer;
        fileName += zipFileExt;
        type = zipType;
    }
    else {
        blobContent = objects[0].edoc;
        fileName += tslFileExt;
        type = appType;
    }
    downloadFileUtil({
        blob: new Blob([blobContent], { type }),
        fileName,
    });
};
export const downloadExportedRoles = (epack, shouldExportDependencies, customName) => {
    const objects = epack.object;
    const containsMultipleObjects = objects.length > 1;
    let fileName = '';
    if (containsMultipleObjects) {
        fileName = customName || ROLES;
    }
    else {
        const suffix = ROLES.toLocaleLowerCase();
        fileName = `${customName ||
            objects[0].name ||
            objects[0].id}.${suffix}`;
    }
    downloadFile(epack, fileName, containsMultipleObjects, shouldExportDependencies);
};
//# sourceMappingURL=download-roles.util.js.map